export const APP_USER_AGENT_REGEX = /<\s(.*[^\/])\/(.*[^\s])\s(.*[^\s])\s(.*[^\s])/;
